
import { CMSResource } from "app/resources/cmsresource";
import { CityResource } from './CityResource';
import { CountyResource } from './CountyResource';

export class KioskResource extends CMSResource {
    rid: number;
    serialNo: string;
    companyName: string;
    //location: string;
    commentsRo: string;
    commentsEn: string
    commentsFr: string;
    commentsDe: string;
    userEmail: string;
    nameRo: string;
    nameFr: string;
    nameEn: string;
    nameDe: string;
    shortDescRo: string;
    shortDescEn: string;
    shortDescFr: string;
    shortDescDe: string;
    county: CountyResource;
    city: CityResource;
    address: string;
    postalCode: string;
    latitude: string
    longitude: string
    notificationEmail: string;

    showDetailsOnResponsive: boolean = false;
}